const SITE_KEY = '6LcjXkotAAAAAA4TVjNPnHRuIyJ-rcK20d0pLwo_';

export async function getRecaptchaToken(action = 'submit'): Promise<string | null> {
  try {
    // espera o grecaptcha aparecer (até ~5s), em vez de desistir na hora
    let tries = 0;
    while (!(window as any).grecaptcha?.execute && tries < 50) {
      await new Promise(r => setTimeout(r, 100));
      tries++;
    }
    const grecaptcha = (window as any).grecaptcha;
    if (!grecaptcha?.execute) return null; // desistiu após 5s

    await new Promise<void>((resolve) => grecaptcha.ready(() => resolve()));
    const token = await grecaptcha.execute(SITE_KEY, { action });
    return token || null;
  } catch {
    return null;
  }
}